import React from "react";
import { Instagram, Mail, MapPin, Leaf } from "lucide-react";
import { FOOTER_DATA } from "../constants/kalorenceData";

export const Footer = ({ setActiveTab }) => {
  const go = (key) => {
    setActiveTab(key);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#2B3A2F] text-[#F7F5F0] overflow-hidden"
    >
      {/* Decorative botanical band */}
      <div className="relative h-64 sm:h-80 w-full overflow-hidden">
        <img
          src={FOOTER_DATA.bottomImage}
          alt="Kalorence dupatta on bamboo ladder"
          className="absolute inset-0 w-full h-full object-cover opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#2B3A2F] via-[#2B3A2F]/70 to-transparent" />
        <div className="absolute inset-0 flex items-center justify-center text-center px-6">
          <p className="font-cormorant italic text-2xl sm:text-4xl font-light max-w-2xl leading-snug">
            “You wear a single moment in time.”
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <h3 className="text-3xl font-cormorant font-light flex items-center gap-2">
              <Leaf className="w-6 h-6 text-[#C47D65]" />
              {FOOTER_DATA.logo}
            </h3>
            <p className="text-sm text-[#E2DACF]/80 font-light leading-relaxed max-w-sm">
              {FOOTER_DATA.tagline}
            </p>
          </div>

          {/* Explore */}
          <div className="space-y-4">
            <p className="text-xs tracking-[0.2em] uppercase font-semibold text-[#C47D65]">
              Explore
            </p>
            <ul className="space-y-2.5 text-sm font-light">
              {[
                { label: "Home", key: "home" },
                { label: "Story & Craft", key: "story" },
                { label: "Shop", key: "shop" },
                { label: "Care Journal", key: "care" },
                { label: "Contact", key: "contact" },
              ].map((l) => (
                <li key={l.key}>
                  <button
                    data-testid={`footer-link-${l.key}`}
                    onClick={() => go(l.key)}
                    className="hover:text-[#C47D65] transition-colors duration-300 text-[#E2DACF]/90"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <p className="text-xs tracking-[0.2em] uppercase font-semibold text-[#C47D65]">
              The Studio
            </p>
            <ul className="space-y-3 text-sm font-light text-[#E2DACF]/90">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-[#C47D65] shrink-0" />
                {FOOTER_DATA.address}
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#C47D65] shrink-0" />
                <a
                  data-testid="footer-email-link"
                  href={`mailto:${FOOTER_DATA.email}`}
                  className="hover:text-[#C47D65] transition-colors"
                >
                  {FOOTER_DATA.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Instagram className="w-4 h-4 text-[#C47D65] shrink-0" />
                <a
                  data-testid="footer-instagram-link"
                  href={FOOTER_DATA.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#C47D65] transition-colors"
                >
                  @kalorence
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-[#E2DACF]/60 font-light tracking-wide">
          <span>{FOOTER_DATA.copyright}</span>
          <span>Handcrafted with leaves, bark &amp; patience.</span>
        </div>
      </div>
    </footer>
  );
};
